import script from "./HangTonKhoTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./HangTonKhoTable.vue?vue&type=script&lang=ts&setup=true"

import "./HangTonKhoTable.vue?vue&type=style&index=0&id=39609f48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39609f48"]])

export default __exports__